import Cookies from 'js-cookie';

const selectedProduct = 'SelectedProduct';
const onboardPageSource = 'OnboardPageSource';

export const getSelectedProduct = () => Cookies.get(selectedProduct);
export const getOnboardPageSource = () => Cookies.get(onboardPageSource);

export const clearSelectedProduct = (): void => {
  Cookies.remove(selectedProduct, { path: '/' });
};

export const setGlobalCookie = (name: string, value: string, path?: string) => {
  Cookies.set(name, value, { path });
};
